module.exports = __webpack_public_path__ + "images/Mail.83bd1bbaecb10fa97b56d46e2a520ef2.svg";